import React, { useEffect, useState } from 'react';
import { Alert, AlertTitle, Button, Snackbar } from '@mui/material';
import { FEATURE_FLAGS } from '../../constants';
import { startClientLocation, stopClientLocation } from '../../services/clientLocation';
import { getDecryptedCookie } from '../../utils';

// Activity Log (#735): starts browser location tracking once the user is inside PBA and shows the
// "Location Details Not Captured" notice once per session. Non-blocking: a small card, the screen
// stays usable and the user's action has already continued. Renders nothing while
// REACT_APP_LOCATION_HEADERS is off.
export default function LocationNotice() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!FEATURE_FLAGS.LOCATION_HEADERS || !getDecryptedCookie('bid')) return undefined;
        startClientLocation(() => setOpen(true));
        return () => stopClientLocation();
    }, []);

    if (!FEATURE_FLAGS.LOCATION_HEADERS) return null;

    return (
        <Snackbar
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ top: { xs: 72, sm: 88 }, maxWidth: { xs: 'calc(100% - 16px)', sm: 420 } }}
        >
            <Alert
                severity='warning'
                variant='filled'
                sx={{ width: '100%', boxShadow: 6 }}
                action={
                    <Button color='inherit' size='small' onClick={() => setOpen(false)} sx={{ fontWeight: 700 }}>
                        OK
                    </Button>
                }
            >
                <AlertTitle sx={{ fontWeight: 700 }}>Location Details Not Captured</AlertTitle>
                Your location permission was denied. Latitude and longitude details will not be stored in the Activity
                Log for this action. Other available activity details will still be recorded.
            </Alert>
        </Snackbar>
    );
}
